import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//Components
import HousekeyRow from './Housekey.constants';
import Layout from '../common/Layout';
import Wrapper from '../common/Wrapper';
import SearchForm from '../common/Search/SearchForm';
import TableHeader from '../common/Table/TableHeader';
import Loading from '../common/Loading';
import { useSyles } from '../common/Wrapper/styles';
//Material
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getAllHousekeys } from '../../redux/housekeys/thunks';
import { fieldsFilter, headCells, valuesEstatus } from './constants.constants';
import useScan from '../../hooks/useScan';
import { SystemActions } from '../../domain/constants/SystemActions';
import { RolePermissions } from '../../domain/constants/RolePremissions';
import { getSorting, stableSort } from 'src/helpers/sorts';

const Housekeys = (props: any) => {
  const classes = useSyles();
  const { auth } = useSelector((state: any) => state);
  const allowEdit = RolePermissions.allowed(
    Number(auth.type),
    SystemActions.edit_keys
  );
  const dispatch = useDispatch<any>();
  const navigate = useNavigate(); // habilitar navigate para redirección
  const [filter, setFilter] = useState('');
  const { setDestination } = useScan();
  const [firstLoad, setFirstLoad] = useState(true);
  // obtener el state
  const { housekeys, loading } = useSelector((state: any) => state.housekeys);
  const { selectedWarehouse } = useSelector((state: any) => state.warehouses);
  const [pagination, setPagination] = useState({
    rowsPerPage: 10,
    page: 1,
    total: 1,
    order: 'desc',
    orderBy: 'name',
  });
  useEffect(() => {
    setDestination('act-l-hou', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateDataByPagination = async () => {
    await dispatch(getAllHousekeys({ filter, pagination }));
  };

  useEffect(() => {
    pagination.page = 1;
    updateDataByPagination();
    setFirstLoad(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, selectedWarehouse]);

  useEffect(() => {
    setPagination({
      ...pagination,
      total: housekeys.paginate?.items ? housekeys.paginate.items : 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [housekeys.paginate]);

  useEffect(() => {
    if (!firstLoad) {
      updateDataByPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.rowsPerPage, pagination.page]);

  // función que redirige de forma programada
  const redirectAdd = () => {
    navigate(`/housekeys/new`, { replace: true });
  };
  //Tabla

  const emptyRows =
    pagination.rowsPerPage -
    Math.min(
      pagination.rowsPerPage,
      pagination.total - pagination.page * pagination.rowsPerPage
    );
  const { order, orderBy } = props;

  const handleChangePage = (event: any, page: any) => {
    setPagination({
      ...pagination,
      page: ++page,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPagination({
      ...pagination,
      rowsPerPage: event.target.value,
    });
  };

  //Fin de tabla
  //Filtros
  const initialValuesFilter = {
    key: 'barcode',
    name_value: '',
  };

  // cuando el usuario haga submit en el formulario de busqueda
  const submitFilterHousekeys = (values: any) => {
    //preparar la data para filtrar
    if (values.key !== '' && values.name_value !== '') {
      setFilter(`&${values.key}=${values.name_value}`);
    } else {
      setFilter('');
    }
  };
  const sliceX = 0;
  const sliceY = pagination.rowsPerPage;
  //Fin de los filtros
  return (
    <Layout>
      <Wrapper
        button={allowEdit}
        buttonTitle='Agregar llave'
        actionTitle={() => redirectAdd()}
      >
        <Grid className={classes.containerHeader} container item spacing={4}>
          <Grid item xs={12} sm={8} md={8} className={classes.button}>
            <SearchForm
              submitFilter={submitFilterHousekeys}
              fields={fieldsFilter}
              valuesEstatus={valuesEstatus}
              initialValues={initialValuesFilter}
              filter='k'
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} className={classes.button}>
            <Button
              size='medium'
              color='secondary'
              variant='contained'
              onClick={() => redirectAdd()}
            >
              Agregar llave
              <Add />
            </Button>
          </Grid>
        </Grid>
        {!loading ? (
          <>
            {housekeys?.keys?.length > 0 ? (
              <div>
                <TableContainer component={Paper}>
                  <Table aria-label='simple table'>
                    <TableHeader cellsList={headCells} />
                    <TableBody>
                      {stableSort(housekeys?.keys, getSorting(order, orderBy))
                        .slice(sliceX, sliceY)
                        .map((housekey: any) => {
                          return (
                            <HousekeyRow
                              key={`housekey-${housekey.id}`}
                              housekey={housekey}
                            />
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 49 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 50]}
                  component='div'
                  count={pagination.total}
                  rowsPerPage={pagination.rowsPerPage}
                  page={pagination.page - 1}
                  labelRowsPerPage='Renglones por página'
                  backIconButtonProps={{
                    'aria-label': 'Anterior',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Siguiente',
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            ) : (
              <div>No hay datos</div>
            )}
          </>
        ) : (
          <Loading />
        )}
      </Wrapper>
    </Layout>
  );
};

export default Housekeys;
